<div class="p-2">
  <tk-tabs [active]="activeTab" (activeChange)="activeTab = $event; tabChanged()">
    <button tkActions class="btn btn-sm btn-outline-success px-4" (click)="createNew()">
      <i class="bi bi-plus bi-lg"></i>
      @switch (activeTab) {
        @case (1) {
          <span>{{'users.new'|translate}}</span>
        }
        @case (2) {
          <span>{{'groups.new'|translate}}</span>
        }
        @case (3) {
          <span>{{'templates.new'|translate}}</span>
        }
      }
    </button>

    <tk-tab [tabId]="1" label="users.users">
      <ng-template tkTabBody>
        <tk-table [cols]="userCols" [refreshUrl]="userRefreshUrl" [detailUrl]="userDetailUrl"
          [detailId]="userDetailId">
        </tk-table>
      </ng-template>
    </tk-tab>

    <tk-tab [tabId]="2" label="groups.groups">
      <ng-template tkTabBody>
        <tk-table [cols]="groupCols" [refreshUrl]="groupRefreshUrl" [detailUrl]="groupDetailUrl"
          [detailId]="groupDetailId" (rowsLoaded)="assignAll($event)">
        </tk-table>
      </ng-template>
    </tk-tab>
  </tk-tabs>
</div>
